export const THEME_TYPO_TOKEN = {
  '--display-2XL':
    '700 2.5rem/1.618 Rupa Serif, Helvetica, Open Sans, sans-serif',
  '--display-XL':
    '700 2.25rem/1.618 Rupa Serif, Helvetica, Open Sans, sans-serif',
  '--display-L': '700 2rem/1.618 Rupa Serif, Helvetica, Open Sans, sans-serif',
  '--display-M':
    '700 1.75rem/1.618 Rupa Serif, Helvetica, Open Sans, sans-serif',
  '--heading-2XL': '600 2.5rem/1.5 Rupa Sans, Helvetica, Open Sans, sans-serif',
  '--heading-XL': '600 2.25rem/1.5 Rupa Sans, Helvetica, Open Sans, sans-serif',
  '--heading-L': '600 2rem/1.5 Rupa Sans, Helvetica, Open Sans, sans-serif',
  '--heading-M': '600 1.75rem/1.5 Rupa Sans, Helvetica, Open Sans, sans-serif',
  '--heading-S': '600 1.5rem/1.5 Rupa Sans, Helvetica, Open Sans, sans-serif',
  '--heading-XS': '600 1.25rem/1.5 Rupa Sans, Helvetica, Open Sans, sans-serif',
  '--text-bold-L':
    '600 1.125rem/1.5 Rupa Sans, Helvetica, Open Sans, sans-serif',
  '--text-bold-M': '600 1rem/1.5 Rupa Sans, Helvetica, Open Sans, sans-serif',
  '--text-bold-S':
    '600 0.875rem/1.5 Rupa Sans, Helvetica, Open Sans, sans-serif',
  '--text-bold-XS':
    '600 0.75rem/1.5 Rupa Sans, Helvetica, Open Sans, sans-serif',
  '--text-regular-2XL':
    '500 1.5rem/1.618 Rupa Sans, Helvetica, Open Sans, sans-serif',
  '--text-regular-XL':
    '500 1.25rem/1.618 Rupa Sans, Helvetica, Open Sans, sans-serif',
  '--text-regular-L':
    '500 1.125rem/1.618 Rupa Sans, Helvetica, Open Sans, sans-serif',
  '--text-regular-M':
    '500 1rem/1.618 Rupa Sans, Helvetica, Open Sans, sans-serif',
  '--text-regular-S':
    '500 0.875rem/1.618 Rupa Sans, Helvetica, Open Sans, sans-serif',
  '--text-regular-XS':
    '500 0.75rem/1.618 Rupa Sans, Helvetica, Open Sans, sans-serif',
  '--text-regular-XXS':
    '500 0.625rem/1.618 Rupa Sans, Helvetica, Open Sans, sans-serif',
};
